import type { FC } from 'react';
import {
  Box,
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import Title from 'src/components/admin/Title';
import Scrollbar from 'src/components/admin/Scrollbar';
import TableCellHeaderBasic from 'src/components/global/TableCellHeaderBasic';
import SeguimientoOficinaDetailRow from 'src/pages/dashboard/seguimiento-oficina/SeguimientoOficinaDetailRow';
import { numberToMillons } from 'src/utils/functions';

interface PropsSeguimientoOficinaDetail {
  content: {
    data: any;
    resume: { operaciones: number; facturacion: number; meta: number };
    pages: { total: number; current: number; limit: number };
  };
  handleChangePage: (event: unknown, page: number) => Promise<void>;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
  level: number;
}

const SeguimientoOficinaDetail: FC<PropsSeguimientoOficinaDetail> = ({
  content,
  handleChangePage,
  handleChangeRowsPerPage,
  level,
}) => {
  const title = 'Facturación por Territorios, En unidades, MM de PEN';
  const headers = [
    { label: 'Equipo', width: '400px' },
    { label: 'Operaciones', width: '150px' },
    { label: 'Facturación', width: '150px' },
    { label: 'Meta', width: '100px' },
    { label: 'Aporte de Fact.', width: '100px' },
  ];

  return (
    <>
      <Box pt={2}>
        <Title title={title} />
        <Card>
          <Scrollbar>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {headers.map((header, index) => (
                    <TableCellHeaderBasic
                      key={header.label}
                      align={index !== 0 ? 'right' : 'left'}
                      width={header.width}
                    >
                      {header.label}
                    </TableCellHeaderBasic>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {content.data.map((item, index) => {
                  const key = `row-detail-${index}`;
                  return (
                    <SeguimientoOficinaDetailRow
                      key={key}
                      item={item}
                      level={level}
                    />
                  );
                })}
              </TableBody>
              <TableHead>
                <TableRow>
                  <TableCellHeaderBasic>Total</TableCellHeaderBasic>
                  <TableCellHeaderBasic align="right">
                    {content.resume.operaciones}
                  </TableCellHeaderBasic>
                  <TableCellHeaderBasic align="right">
                    {numberToMillons(content.resume.facturacion)}
                  </TableCellHeaderBasic>
                  <TableCellHeaderBasic align="right">
                    {numberToMillons(content.resume.meta)}
                  </TableCellHeaderBasic>
                  <TableCellHeaderBasic />
                </TableRow>
              </TableHead>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    backIconButtonProps={{
                      title: 'Página anterior',
                    }}
                    nextIconButtonProps={{
                      title: 'Página siguiente',
                    }}
                    rowsPerPageOptions={[5, 10, 15, 20]}
                    labelRowsPerPage="Registros por página"
                    labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                    count={content.pages.total}
                    page={content.pages.current}
                    rowsPerPage={content.pages.limit}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </Scrollbar>
        </Card>
      </Box>
    </>
  );
};

export default SeguimientoOficinaDetail;
